module.exports = __webpack_public_path__ + "static/img/Store-7.7714cef9.png";